import { render, staticRenderFns } from "./BaseOpenService.vue?vue&type=template&id=3e4ad3b1&scoped=true&"
import script from "./BaseOpenService.vue?vue&type=script&lang=js&"
export * from "./BaseOpenService.vue?vue&type=script&lang=js&"
import style0 from "./BaseOpenService.vue?vue&type=style&index=0&id=3e4ad3b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ad3b1",
  null
  
)

export default component.exports